<template>
  <div class="linkBox">
    <div class="left" />
    <div class="right" />
    <!--<img src="https://static.didapinche.com/pics/g/coupontemplate_connectline.png" alt="" class="left-linkicon">-->
    <!--<img src="https://static.didapinche.com/pics/g/coupontemplate_connectline.png" alt="" class="right-linkicon">-->
    <div class="linkBox-item" @click="toLink">
      <div class="content-title">
        <div>{{ linkdata[0].title }}</div>
        <div v-if="linkdata[0].subtitle" class="stitle">{{ linkdata[0].subtitle }}</div>
      </div>
      <img v-if="linkdata[0].img_url" :src="linkdata[0].img_url" alt="">
    </div>
  </div>
</template>

<script>
  export default {
    name: 'LinkBox',
    props: ['linkdata'],
    data() {
      return {
        // linkdata: {
        //   title: '顺风车周卡1元购',
        //   subtitle: '副标题副标题副',
        //   imgurl: 'https://static.didapinche.com/pics/g/coupontemplate_couponbg.png',
        //   link: ''
        // }
      }
    },
    created() {
    },
    methods: {
      toLink() {
        if (this.linkdata[0].link) {
          window.location = this.linkdata[0].link
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .linkBox {
    width: 100%;
    padding: 0.42rem 0;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.1rem 0.28rem 0 rgba(0, 0, 0, 0.15);
    border-radius: 0.26rem;
    margin-top: 0.24rem;
    position: relative;
  }

  .left {
    position: absolute;
    left: 0.38rem;
    top: -0.5rem;
    width: 0.12rem;
    height: 0.8rem;
    background: url("https://static.didapinche.com/pics/g/coupontemplate_connectline.png") no-repeat;
    background-size: 100%;
  }

  .right {
    position: absolute;
    right: 0.32rem;
    top: -0.5rem;
    width: 0.12rem;
    height: 0.8rem;
    background: url("https://static.didapinche.com/pics/g/coupontemplate_connectline.png") no-repeat;
    background-size: 100%;
  }

  .left-linkicon {
    display: block;
    width: 0.11rem;
    /*height: 0.5rem;*/
    position: absolute;
    left: 0.38rem;
    top: -0.5rem;
  }

  .right-linkicon {
    display: block;
    width: 0.11rem;
    /*height: 0.8rem;*/
    position: absolute;
    right: 0.32rem;
    top: -0.5rem;
  }

  .linkBox-item {
    padding: 0 0.42rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    img {
      width: 2.24rem;
      height: 1.5rem;
    }
  }

  .content-title {
    width: 3.62rem;
    color: #292D39;
    font-size: 0.32rem;
    font-weight: bold;
  }

  .stitle {
    color: #868DA3;
    font-size: 0.22rem;
    padding-top: 0.08rem;
    font-weight: normal;
  }

</style>
